import { Box, Skeleton } from '@mui/material';
import { useSelector } from 'react-redux';

import defaultProfile from 'app/assets/default-profile.svg';
import getBadges from '../../../../utils/getBadges';
import BadgeDisplay from '../BadgeDisplay';

export default function PatientFileHeader({ patient, isLoading, showBadges }) {
  const user = useSelector(({ auth }) => auth.user);
  const isSupport = user?.roles?.includes('support');

  if (isLoading) return <LoadingState />;

  const badges = showBadges && getBadges(patient);

  return (
    <Box className="flex gap-12 items-center">
      <img
        className="w-48 h-48 rounded-full"
        src={patient?.avatar_url || defaultProfile}
        alt="Patient avatar"
        onError={(e) => {
          e.target.src = defaultProfile;
        }}
      />
      <Box className="flex flex-col gap-4">
        <Box className="font-600 text-h1 capitalize">
          {patient.forename} {patient.surname}
        </Box>
        {showBadges && (
          <BadgeDisplay badges={badges} isSupport={isSupport} showBadges={showBadges} />
        )}
      </Box>
    </Box>
  );
}

function LoadingState() {
  return (
    <Box className="flex gap-12 items-center">
      <Skeleton className="mr-10" variant="circular" width={48} height={48} />
      <Box className="flex flex-col gap-4">
        <Skeleton variant="rounded" height={20} width={100} />
        <Skeleton variant="rounded" height={20} width={50} />
      </Box>
    </Box>
  );
}
